var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFileDocIcon = function SvgFileDocIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 28",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7c0 .97.89 1.75 2 1.75h8V28H0V0h14v7zm6 6.125c0-.479-.438-.875-1-.875H5c-.547 0-1 .396-1 .875S4.453 14 5 14h14c.563 0 1-.396 1-.875zM16 0l8 7h-8V0zm3 19.25c.563 0 1-.396 1-.875s-.438-.875-1-.875H5c-.547 0-1 .396-1 .875s.453.875 1 .875h14zm0 5.25c.563 0 1-.396 1-.875s-.438-.875-1-.875H5c-.547 0-1 .396-1 .875s.453.875 1 .875h14z",
    fill: "currentColor"
  })));
};
export default SvgFileDocIcon;